// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3MtA7","inner":"Footer_inner__2IsNI"};